
import request from '@/utils/request'
import axios from "../utils/request";
const qiniu = require('qiniu-js')
export function upload(files, scene_name) {
  return new Promise((resolve, reject) => {
    let n = 0, urlArray = [];
    files.forEach((file, index)=>{
      request({
        url: '/admin/v1/getUploadToken',
        method: 'post',
        data: {
          model_name: 'admin',
          scene_name: scene_name
        }
      }).then((({ data })=>{
        if(data.code == 0){
          let lastInx = file.name.lastIndexOf('.');
          let name = file.name.slice(lastInx, file.name.length);
          
          let key = data.data.dir + name;   //这是上船后返回的文件名，这里为了避免重复，加上了时间戳和随机数
          var config = {
            useCdnDomain: true,        //表示是否使用 cdn 加速域名
            domain: data.data.request_url, //七牛云域名
            chunkSize: 100, //每个分片的大小，单位mb，默认值3
            forceDirect: true //直传还是断点续传方式，true为直传
          };            
          var putExtra = {
            fname: file.name,    //文件原始文件名
            params: {},
            mimeType: [] || null
          };
          var observable = qiniu.upload(file, key, data.data.token, putExtra, config);
          observable.subscribe({
              next: (result) => {
                //主要用来展示进度
              },
              error: (err) => {
                reject(err)
              },
              complete: (result) => {
                urlArray.push(data.data.request_url + '/' + key)
                n ++
                if(n == files.length){
                  resolve(urlArray)
                }
              }
          })
        }
      }))
    })
  })
}
